export default {
  label: "Reporting",
};
